export default __webpack_public_path__ + "static/media/edit.6d0088c2.PNG";